import { defineAsyncComponent } from 'vue'
export default {
  cart: defineAsyncComponent(() => import("/app/layouts/Cart.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/app/layouts/default.vue").then(m => m.default || m))
}